import { Tags } from '@/api/models/tags'

const state = {
    loaded: false,
    list: [],
    groups: [],
    tag: [],
}

const mutations = {
    LOADED(state) {
        state.loaded = true
    },

    SET_LIST(state, val) {
        state.list = val
    },

    SET_TAG(state, val) {
        state.tag = val
    },

    SET_GROUPS(state) {
        state.groups = state.tag.groups
    },
}

const actions = {
    async fetch({ commit, getters }, route) {
        const tagList = new Tags()
        const result = await tagList.fetch(route)
        commit('SET_LIST', result?.data || result)
        commit('SET_TAG', tagList)
        commit('SET_GROUPS')
        commit('LOADED')
        return getters.loaded
    },
}

const getters = {
    loaded: (state) => state.loaded,
    all: (state) => state.list,
    featured: (state) => state.list?.filter((el) => el.is_featured && !!el.restaurant_count),
    notFeatured: (state) => state.list?.filter((el) => !el.is_featured && !!el.restaurant_count),
    groups: (state) => state.groups,
    showTagSelect: (state, getters, rootState, rootGetters) =>
        (!rootGetters['site/listFiltered'] || !rootGetters['smDevice']) && getters.featured?.length,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
